import $axios from "../api/accessor";
import { $api } from "../api/api";

export const OrdersService = {
  async getAllSellers() {
    let response = await $axios
      .get($api("orders_sellers"), {
       
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getAllStoreCategory() {
    let response = await $axios
      .get($api("orders_categories"), {
       
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getAllStoreCurrency() {
    let response = await $axios
      .get($api("orders_currency"), {
       
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
